export default function AdminNavService(gettext) {
	'ngInject';

	'ngInject';

	var module = {
		id: 'admin',
		name: 'Admin',
		sref: 'admin',
		icon: 'fas fa-cog',
		priority: 10,
		items: [
			{
				name: gettext('Users'),
				mobileName: gettext('View Users'),
				sref: 'admin.userslist',
				group: 'userManagment'
			},
			{
				name: gettext('Roles'),
				mobileName: gettext('View Roles'),
				sref: 'admin.usersRoleslist',
				group: 'userManagment'
			},
			{
				name: gettext('Security'),
				mobileName: gettext('View Security Groups'),
				sref: 'admin.securitygroups',
				group: 'userManagment'
			},
			{
				name: gettext('Sub Accounts'),
				sref: 'admin.subaccounts',
				group: 'accountManagement'
			},
			{
				name: gettext('Templates'),
				mobileName: gettext('View Templates'),
				sref: 'admin.products-list',
				group: 'assets'
			},
			{
				name: gettext('Sharing'),
				sref: 'admin.manage',
				group: 'assets'
			},
			{
				name: gettext('Attributes'),
				mobileName: gettext('View Attributes'),
				sref: 'admin.tag-list',
				group: 'assets'
			}
		],
		groups: [
			{
				id: 'userManagment',
				name: gettext('User Management')
			},
			{
				id: 'accountManagement',
				name: gettext('Account Management')
			},
			{
				id: 'assets',
				name: gettext('Assets')
			}
		]
	};

	return {
		getModule: () => module
	};
}
